define("calendar/utils/constants", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.POST_MARKUP_ICONS = _exports.POST_MARKUP_CLASSES = _exports.NOTE_MAXIMUM_CHARACTERS = _exports.NOTE_ERRORS = _exports.NOTE_CHARACTER_LIMIT_THRESHOLD = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f

  // NOTE: MARKUP_ICONS are typically reusable icon strings being passed into `appendDiv` in
  // the calendar `markup` service.
  const POST_MARKUP_ICONS = Object.freeze({
    AUTO_PUBLISH: 'fc-icon-instant',
    AUTO_PUBLISH_ERROR: 'fc-icon-instant--error',
    DANGER: 'i-danger-1',
    FC_VERIFIED: 'fc-icon-verified',
    GALLERY: 'fc-icon-gallery',
    HELP: 'fc-icon-help',
    HIDDEN: 'fc-icon-hidden',
    NOTICE: 'i-notice',
    NOTIFICATION: 'fc-icon-notify',
    PENDING: 'i-pending',
    PUBLISHING: 'fc-icon-publishing',
    REELS: 'fc-icon-reels',
    VERIFIED: 'i-verified',
    WARNING: 'fc-icon-warning'
  }); // NOTE: MARKUP_CLASSES are typically reusable class strings being passed into `appendDiv` and
  // `addClass` the calendar `markup` service.

  _exports.POST_MARKUP_ICONS = POST_MARKUP_ICONS;
  const POST_MARKUP_CLASSES = Object.freeze({
    FC_BUTTON_ACTIVE: 'fc-button-active',
    FC_METHOD: 'fc-method',
    FC_METHOD_DANGER: 'fc-method u--text--danger',
    FC_POST: 'fc-post',
    FC_STATUS: 'fc-status',
    FC_TYPE: 'fc-type',
    HAS_ERROR: 'has--error',
    IS_NARROW: 'is--narrow',
    IS_PUBLSHING: 'is--publishing',
    IS_UNVERIFIED: 'is--unverified',
    IS_VERIFIED: 'is--verified',
    TEXT_POST: 'fc-post-text'
  }); // NOTE: Calendar Notes

  _exports.POST_MARKUP_CLASSES = POST_MARKUP_CLASSES;
  const NOTE_CHARACTER_LIMIT_THRESHOLD = 2400;
  _exports.NOTE_CHARACTER_LIMIT_THRESHOLD = NOTE_CHARACTER_LIMIT_THRESHOLD;
  const NOTE_MAXIMUM_CHARACTERS = 2500;
  _exports.NOTE_MAXIMUM_CHARACTERS = NOTE_MAXIMUM_CHARACTERS;
  const NOTE_ERRORS = Object.freeze({
    SCHEDULE_OVERLAP: "Scheduled at can't overlap"
  });
  _exports.NOTE_ERRORS = NOTE_ERRORS;
});